import React from 'react';
import './PhysicalExam.css';

const PhysicalExam = ({ physicalExam, onChange }) => {
  const handleFieldChange = (field, value) => {
    onChange({
      ...physicalExam,
      [field]: value
    });
  };

  const examFields = [
    { key: 'labios', label: 'Labios' },
    { key: 'lengua', label: 'Lengua' },
    { key: 'carrillos', label: 'Carrillos' },
    { key: 'paladarDuro', label: 'Paladar duro' },
    { key: 'paladarBlando', label: 'Paladar blando' },
    { key: 'cabezaYCuello', label: 'Cabeza y cuello' },
    { key: 'pisoDeBoca', label: 'Piso de boca' },
    { key: 'glandSalivales', label: 'Gland. salivales' },
    { key: 'ganglios', label: 'Ganglios' },
    { key: 'parodonto', label: 'Parodonto' },
    { key: 'oclusion', label: 'Oclusión' },
    { key: 'atm', label: 'ATM' }
  ];

  return (
    <div className="physical-exam-section">
      <h3 className="questionnaire-title">EXPLORACIÓN FÍSICA ODONTOLÓGICA</h3>

      <div className="physical-exam-grid">
        {examFields.map((field) => (
          <div key={field.key} className="physical-exam-field">
            <label htmlFor={field.key}>{field.label}</label>
            <textarea
              id={field.key}
              value={physicalExam[field.key] || ''}
              onChange={(e) => handleFieldChange(field.key, e.target.value)}
              placeholder={`Observaciones sobre ${field.label.toLowerCase()}`}
              rows="2"
              maxLength="500"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhysicalExam;
